import Spinner from 'src/javascripts/components/utilities/Spinner';
import AssessmentSliders from 'src/javascripts/components/forms/AssessmentSliders';
import 'ion-rangeslider/js/ion.rangeSlider';

// Edit impact framework category (importance rating)
export default class AssessmentsEditPillar {

  constructor() {}

  render() {

  	AssessmentSliders();

  }

}